module.exports = __webpack_public_path__ + "img/aboutBanner.2447bec9.png";